import { OnInit, OnChanges, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { includes } from '../../../shared';
var SelectDivisionsComponent = /** @class */ (function () {
    function SelectDivisionsComponent(fb) {
        this.fb = fb;
        this.form = this.fb.array([]);
        this.selectDivision = new EventEmitter();
    }
    SelectDivisionsComponent.prototype.ngOnInit = function () {
        this.initForm();
    };
    SelectDivisionsComponent.prototype.ngOnChanges = function () {
        this.initForm();
    };
    SelectDivisionsComponent.prototype.initForm = function () {
        var _this = this;
        var controls = this.divisions.map(function (d) {
            return _this.fb.control(false);
        });
        this.form = this.fb.array(controls);
        if (this.formChanges && this.formChanges.unsubscribe) {
            this.formChanges.unsubscribe();
        }
        this.formChanges = this.form.valueChanges.subscribe(function (value) {
            _this.selectDivision.emit(_this.selectedDivisionIds);
        });
    };
    SelectDivisionsComponent.prototype.generateName = function (division) {
        if (division.description.replace(/\s/g, '')) {
            return division.name + " - " + division.description; // + `id = ${division.id} - exclusions =${division.exclusions}`;
        }
        else {
            return "" + division.name;
        }
    };
    Object.defineProperty(SelectDivisionsComponent.prototype, "selectedDivisions", {
        get: function () {
            var _this = this;
            var formValue = this.form.value;
            var selectedIdxs = formValue
                .map(function (element, i) {
                return { value: element, index: i };
            })
                .filter(function (element) { return element.value; })
                .map(function (element) { return element.index; });
            return selectedIdxs.map(function (i) { return _this.divisions[i]; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectDivisionsComponent.prototype, "selectedDivisionIds", {
        get: function () {
            return this.selectedDivisions.map(function (division) { return division.id; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectDivisionsComponent.prototype, "exclusions", {
        get: function () {
            return this.selectedDivisions
                .map(function (division) { return division.exclusions; })
                .filter(function (arr) { return arr.length !== 0; })
                .join(',')
                .split(',')
                .map(function (num) { return Number(num); });
        },
        enumerable: true,
        configurable: true
    });
    SelectDivisionsComponent.prototype.includes = function (arr, element) {
        return includes(arr, element);
    };
    return SelectDivisionsComponent;
}());
export { SelectDivisionsComponent };
